export default __webpack_public_path__ + "static/media/1895.2fcd47f1.png";